import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import { media } from '~ui-kit';

import { addToast, removeToast, getToasts } from './ducks';

// Components
import Toast from './components/Toast';
import styles from './components/Toast.scss';

const transitionNames = {
  enter: styles.animEnter,
  enterActive: styles.animEnterActive,
  exit: styles.animLeave,
  exitActive: styles.animLeaveActive,
  appear: styles.animAppear,
  appearActive: styles.animAppearActive,
};

const propTypes = {
  toasts: PropTypes.array.isRequired,
  // addToast: PropTypes.func.isRequired,
  removeToast: PropTypes.func.isRequired,
};

const DEFAULT_TIMEOUT = 3000;

class ToastContainer extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.toasts.length > prevProps.toasts.length) {
      // Get the new toast
      const { toasts } = this.props;
      const newToast = toasts[toasts.length - 1];
      const timeout = newToast.timeout || this.props.timeout || DEFAULT_TIMEOUT;

      // Hide toast after timeout
      setTimeout(() => this.props.removeToast(newToast.id), timeout);
    }
  }

  render() {
    const { toasts, mobile } = this.props;

    return (
      <ToastsWrapper mobile={mobile} ignoreClicks={toasts.length === 0}>
        <TransitionGroup>
          {toasts.map(toast => (
            <CSSTransition
              key={toast.id}
              classNames={transitionNames}
              timeout={500}
              appear
            >
              <Toast toast={toast} remove={this.props.removeToast} />
            </CSSTransition>
          ))}
        </TransitionGroup>
      </ToastsWrapper>
    );
  }
}

// Styled components
const ToastsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: ${props => (props.mobile ? '65px' : '0')};
  right: 0px;
  width: 400px;
  z-index: 20;
  padding: 0px 32px;
  ${props => props.ignoreClicks && 'pointer-events: none;'}

  ${media.tablet`
    width: 100%;
  `}
`;

export const useToast = () => {
  const dispatch = useDispatch();

  return {
    success: message => dispatch(addToast({ message, type: 'SUCCESS' })),
    error: message => dispatch(addToast({ message, type: 'ERROR' })),
    info: message => dispatch(addToast({ message, type: 'INFO' })),
    warning: message => dispatch(addToast({ message, type: 'WARNING' })),
  };
};

ToastContainer.propTypes = propTypes;

const mapStateToProps = state => ({
  toasts: getToasts(state),
  mobile: !state.reducer.isDesktop,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      addToast,
      removeToast,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ToastContainer);
